import { Pagination } from "@core/domain/models/pagination";
import { ProjectExpenseRepository } from "@project/data/repositories/project-expense.repository";
import { inject, injectable } from "inversify";
import { ExpenseSearchFilters } from "../../models/expenses/expense-search-filters";
import { Expenses } from "../../models/expenses/expenses.model";

@injectable()
export class GetAllExpensesUseCase {
    constructor(
        @inject(ProjectExpenseRepository)
        private readonly projectExpenseRepository: ProjectExpenseRepository,
    ) {}

    async execute(
        pagination: Pagination,
        filters?: ExpenseSearchFilters,
    ): Promise<Expenses> {
        const expensesResult = await this.projectExpenseRepository.searchBy(
            pagination,
            filters,
        );

        return expensesResult.fold(
            () => new Expenses([], 0),
            (expenses) => expenses,
        );
    }
}
